<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app{
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue